import React from 'react'

import { fetchAtHomeBookings } from 'api/atHome'

import { bookingRow } from './format'
import AtHomeCrudPage from './shared/AtHomeCrudPage'
import { parentLinkOptions } from './shared/parentLink'

// Attended → Feedback (owner, 2026-10-21): what parents answered on the
// WhatsApp feedback message sent after every attended session, trial and
// regular together, newest answer first (the server's order). The lead
// columns match the Attended tabs; Session type says which kind a row is.
// A "Not great" also opens an issue (Issues page) for ops to follow up.
const columnsFor = (rowsRef) => [
  { name: 'bookedOnLabel', label: 'Booked on', options: { keepOrder: true } },
  { name: 'bookedAtLabel', label: 'Booked at', options: { keepOrder: true } },
  { name: 'categoryName', label: 'Category' },
  { name: 'teacherName', label: 'Teacher' },
  {
    name: 'parentName',
    label: 'Parent',
    options: parentLinkOptions(rowsRef, 'parentName')
  },
  {
    name: 'parentPhone',
    label: "Parent's phone",
    options: parentLinkOptions(rowsRef, 'parentPhone')
  },
  { name: 'childName', label: 'Child' },
  { name: 'childGradeLabel', label: "Child's grade" },
  { name: 'schoolName', label: 'School' },
  { name: 'dateLabel', label: 'Session date', options: { keepOrder: true } },
  { name: 'timeLabel', label: 'Session time', options: { keepOrder: true } },
  { name: 'apartmentName', label: "Apartment (the child's home)" },
  { name: 'kindLabel', label: 'Session type' },
  { name: 'feedbackLabel', label: "Parent's feedback" },
  {
    name: 'feedbackAtLabel',
    label: 'Feedback received',
    options: { keepOrder: true }
  }
]

const AtHomeFeedback = () => {
  // The rows as drawn, for the parent-link cells.
  const rowsRef = React.useRef([])

  const fetchList = React.useCallback(async () => {
    const list = (await fetchAtHomeBookings({ view: 'feedback' })).map(
      bookingRow
    )
    rowsRef.current = list
    return list
  }, [])

  return (
    <AtHomeCrudPage
      subtitle="What parents answered on the WhatsApp feedback message after each attended session."
      entityLabel="Feedback"
      fetchList={fetchList}
      columns={columnsFor(rowsRef)}
    />
  )
}

export default AtHomeFeedback
